<script>
  import { onMount } from 'svelte'
  import DataTable from '../DataTable/DataTable.svelte'
  import { Button } from 'smelte'
  import { conditionMonitoringAPI } from './api.js'
  import { fmtDate, statusColor } from './utils'
  import { protocol } from './store'
  import { push, location, querystring } from 'svelte-spa-router'
  import { faCircle } from '@fortawesome/free-solid-svg-icons'
  import Metrics from '../Metrics.svelte'
  import { selectedInstalledBase, userStore, is } from '../../store'
  import { writable } from 'svelte/store'
  import { parseQuery, setQueryParam } from '../InstallBase/urlQuery'

  let columns = [
    {label: 'Submit Date', field: 'modified_fmt', add: '', w: '64', iconAfter: true},
    {label: 'Project numbers', field: 'su_erp_proj', add: '', w: '64', iconAfter: true},
    {label: 'Submitter ID', field: 'username', add: '', w: '40', iconAfter: true},
    {label: 'Customer', field: 'eu_name', add: '', w: '64', iconAfter: true},
    {label: 'Conveyor No.', field: 'machine_no', add: '', w: '48', iconAfter: true},
    {
      label: 'Status', field: 'status_code', add: '', w: '32', iconAfter: true,
      icon: {
        icon: faCircle,
        color: statusColor
      },
    },
    // {label: ' ', field: 'open', add: 'text-red-800 font-medium', w: '64', iconAfter: true, filterHide: true},
  ]
  let data = []
  let selected = -1
  let details = null
  let measurementsView = []

  let filter = []//[{field: 'machine_no', value: ''}]

  const api = new conditionMonitoringAPI()

  onMount(() => {
    api.getProtocolList()
      .then(res => {
        data = res.data
        data.forEach(p => {
          p.open = 'Measurement Protocol'
          p.id = p['_id']
          p.modified_fmt = fmtDate(p.modified)
        })
        console.log('[DEBUG] protocols', data)
      })
      .catch(err => {
        console.log('[ERROR]', err)
      })
    getState()
  })

  function getState () {
    let queryObj = parseQuery($querystring)
    console.log('[DEBUG] queryObj', queryObj)
    if (queryObj.id != null) {
      filter = [{field: 'machine_no', value: queryObj.id}]
      const i = columns.findIndex(p => p.field === 'machine_no')
      if (i > -1) {
        columns[i].filter = queryObj.id
      }
    }

    if (queryObj.project != null) {
      console.log('queryObj.project', queryObj.project)
      filter = [{field: 'su_erp_proj', value: queryObj.project.toLowerCase()}]
      const i = columns.findIndex(p => p.field === 'su_erp_proj')
      if (i > -1) {
        columns[i].filter = queryObj.project
      }
    }
  }


  function detailsOpenHandler ({detail}) {
    // details = detail
    // getMeasurementsView(details['_id'])
    $protocol = {} // detail // bug hack fix !
    push('/condition-monitoring/protocol/' + detail['_id'])
  }

  function newProtocolHandler () {
    $protocol = {}
    let machine_no = $selectedInstalledBase.no

    let queryObj = parseQuery($querystring)
    console.log('[DEBUG] machine_no', machine_no)
    if(machine_no==null && queryObj.id != null){
      machine_no = queryObj.id
    }

    let query_project_no = queryObj.project
    console.log("[DEBUG] project no", query_project_no)

    if (machine_no != null) {
      push('/condition-monitoring/protocol/new?machine_no=' + machine_no)
      return
    }else if(query_project_no != null){
      push('/condition-monitoring/protocol/new?project=' + query_project_no)
      return
    }
    push('/condition-monitoring/protocol/new')
  }

</script>

<Metrics />

<div class="container mx-auto px-8 pt-2 pb-10 bg-white">

  <div class="flex header bg-white my-12">
    <div class="text-xl text-black text-left flex-grow">CONVEYOR CONDITION MONITORING</div>
    <div class="flex-shrink">
      <Button color="red" remove="rounded" on:click={newProtocolHandler}>
        create new protocol
      </Button>

      {#if is($userStore.roles, 'ib_admin', 'admin')}
        <Button color="secondary" remove="rounded"
                on:click={() => { push('/condition-monitoring/params') }}>
          go to parameters
        </Button>
      {/if}
    </div>
  </div>

  <div class="overflow-x-auto text-gray-700">

    <DataTable columns={columns}
               data={data}
               activationColumn={0}
               current={selected}
               selectable={false}
               minWidth={600}
               bind:filter={filter}
               on:dblclick={detailsOpenHandler} />

  </div>

</div>
